export enum IntegrationExactCountryCodeEnum {
  NL = "nl",
  BE = "be",
  DE = "de",
  FR = "fr",
  GB = "gb",
  US = "us",
  ES = "es",
}
